<!--管理员列表-->
<template>
    <div >
<!--{{fieldValue}}-->
        <!--:multiple="multipleSrc"-->
        <!--{{fieldItem.valueType}}-->

        <!--{{selectItems}}{{fieldValueSrc}}-->
        <el-select
                :disabled="disabled"
                remote
                @change="changeSelect"
                v-model="fieldValueSrc"
                filterable
                reserve-keyword
                placeholder="请输入关键词"
                :remote-method="searchTitle"

                :multiple="multipleSrc||fieldItem.valueType=='CHECKBOX'"

        >
            <el-option
                    :label="defaultLabelStr"
                       value="" >
            </el-option>
            <el-option v-for="item in selectItems"
                    :label="item.title"
                    :value="item.id" :key="item.id">
            </el-option>
            <!--<el-option-->
                    <!--label="非主库"-->
                    <!--:value="0">-->
            <!--</el-option>-->
        </el-select>

    </div>
</template>

<script>
    import formuiService from '../service/formui/FormuiService.js'
    import moment from 'moment'
//订单类型
    export default {
        name: 'OrderIsMainSelect',
        props: ['beanName','fieldName','fieldValue','defaultLabel','multiple','fieldItem','formData','disabled'],
        methods: {
            changeSelect:function () {
//              alert(22)
                this.$emit('setFieldValue', this.fieldName, this.fieldValueSrc.toString())
            },
            updateJsonList:function(jsonList){
                this.jsonList=jsonList
                this.loadData();
            },
            loadData:function(){
//                alert('select__loadData')
                let that=this
                console.log(that.jsonList)
//                if(that.jsonList.length>0){
//                    alert('value:'+that.jsonList[0].value)
//                }
                let jsonStr=encodeURIComponent(JSON.stringify({'queryList':that.jsonList}));
                formuiService.getFormuiForeign(that,{beanName:that.beanName,title:that.title,'jsonQuery':that.jsonList.length>0?jsonStr:''},function (resp) {
                    that.selectItems=resp.selectItems
                })
            },
            searchTitle:function(title){
                let that=this
                if(!title){
                    title=''
                }
                this.title=title
                this.loadData()
//                alert('____'+this.jsonList)
//                let jsonStr=encodeURIComponent(JSON.stringify({'queryList':that.jsonList}));
////                jsonStr=JSON.stringify(that.jsonList);
////                alert(that.jsonList.length)
//                formuiService.getFormuiForeign(that,{beanName:that.beanName,title:title,'jsonQuery':that.jsonList.length>0?jsonStr:''},function (resp) {
//                    that.selectItems=resp.selectItems
//                })
//                this.isMainStore=field
            }

        },

        data () {
            return {
                defaultLabelStr:'请选择',
                selectItems:[],
                fieldValueSrc:'',
                title:'',
                multipleSrc:false,
                jsonList:[],
            }
        },
        mounted(){
//            alert(this.beanName)
        },
        created () {

            let that = this
//            alert(that.beanName)

            if(Array.isArray(this.fieldValue)) {
                this.fieldValueSrc = (this.fieldValue)
            }else if((this.fieldValue&&Number.isInteger(this.fieldValue)==false&&this.fieldValue.indexOf(',')!=-1)||this.fieldItem.valueType=='CHECKBOX'){
              var arr=[]
              if(this.fieldValue){
                arr=this.fieldValue.split(",");
              }
                this.fieldValueSrc=[]
                for(var i=0;i<arr.length;i++){
                    if(arr[i]===''){
                        continue;
                    }
                    this.fieldValueSrc.push(parseInt(arr[i]))
                }
            }else if((this.fieldValue||this.fieldValue===0)&&isNaN(this.fieldValue)==false){

                this.fieldValueSrc=parseInt(this.fieldValue)
//                alert(this.fieldValueSrc+"<<<")
            }
//            alert(this.fieldItem.valueType+"<")
//            alert(this.multiple)
            if(this.multiple){

                this.multipleSrc=this.multiple
            }

//            alert(this.defaultLabel)
            if(this.defaultLabel){
                this.defaultLabelStr=this.defaultLabel
            }

            if(this.fieldItem.joinItems){
//                alert(1)
//                console.log('------------------------------------------------------------------------')
//                console.log(this.fieldItem.joinItems)
                let jsonObj={}
//                let jsonList=''
                for(var i=0;i<this.fieldItem.joinItems.length;i++){
                    jsonObj={}
                    let parentFieldName= this.fieldItem.joinItems[i].parentFieldName
                    let joinFieldName=this.fieldItem.joinItems[i].joinFieldName
                    let value=this.fieldItem.joinItems[i].value
                    jsonObj['parentFieldName']=parentFieldName
                    jsonObj['joinFieldName']=joinFieldName
                    jsonObj['value']=value

                    if(parentFieldName&&this.formData){
//                        alert(this.formData[parentFieldName])
                        if(this.formData[parentFieldName]||this.formData[parentFieldName]===0){
//                            alert(1)
                            jsonObj['value']= parseInt(this.formData[parentFieldName])
                        }
                    }

                    this.jsonList.push(jsonObj)
                }
//                alert(JSON.stringify({queryList:that.jsonList}))
//                console.log(jsonList)

//                that.jsonList=jsonList
//                alert(jsonList)
//                alert('joinQuery:'+this.fieldItem.joinQuery)
            }
            that.searchTitle()
//            alert('_____'+that.jsonList)
        },
//        watch : {
//            fieldItem (){
//                console.log('-----------update foreign select-------------')
////                return this.fieldItem
//            }
////
//        },

    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// node_modules/formui-vue2-vistastory/widget/FormUiForeignSelect.vue